import { schema as normalizrSchema } from "normalizr";

export const schema = new normalizrSchema.Entity("suspect", {}, { idAttribute: 'userID' });
export const schemasArray = new normalizrSchema.Array(schema);